import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";
import { GroupedClockError } from "api/admin";

const GROUPED_CLOCK_ERRORS_QUERY_KEY = ["groupedClockErrors"];

export const useGroupedClockErrors = () => {
  return useQuery({
    queryKey: GROUPED_CLOCK_ERRORS_QUERY_KEY,
    queryFn: () => adminApiClient.getGroupedClockErrors(),
  });
};

export const useDeleteClockError = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (errorGroup: {
      errorMessage: string;
      method: string;
      class: string;
    }) => adminApiClient.deleteClockError(errorGroup),
    onSuccess: (_data, deletedGroup) => {
      queryClient.setQueryData<GroupedClockError[]>(
        GROUPED_CLOCK_ERRORS_QUERY_KEY,
        (previous) =>
          previous?.map((row) =>
            row.errorMessage === deletedGroup.errorMessage &&
            row.method === deletedGroup.method &&
            row.class === deletedGroup.class
              ? { ...row, isDeleted: true }
              : row,
          ),
      );
    },
    onError: () => {
      queryClient.invalidateQueries({
        queryKey: GROUPED_CLOCK_ERRORS_QUERY_KEY,
      });
    },
  });
};
